import type { WeatherServiceReq, WeatherServiceRes } from "types/weatherService.types"

import { api } from "./base"

export const weatherServiceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    weatherService: builder.query<WeatherServiceRes, WeatherServiceReq>({
      query: ({ params }) => ({
        url: `/v1/weather_service`,
        params: {
          ...params,
          format: "json",
        },
      }),
    }),
  }),
})
